"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnPageNavigationBlock = void 0;
const DropdownNav_1 = __importDefault(require("../OnpageNavigation/DropdownNav"));
const react_1 = __importDefault(require("react"));
const HistoryNav_1 = __importDefault(require("../OnpageNavigation/HistoryNav"));
require("../OnpageNavigation/HistoryNav.scss");
const OnPageNavigationBlock = (props) => {
    if (props.data.navigationType.value === 'history')
        return react_1.default.createElement(HistoryNav_1.default, { pageProps: props });
    return react_1.default.createElement(DropdownNav_1.default, { currentTitle: props.parentVar, pageProps: props });
};
exports.OnPageNavigationBlock = OnPageNavigationBlock;
exports.default = exports.OnPageNavigationBlock;
